import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControl, FormHelperText } from 'material-ui/Form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment'

const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: 0,
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing.unit * 2,
    },
});

/*
const inputOnChangeRaw=(e,dateFormat,input)=>{
  if (moment.invalid(e.target.value,dateFormat)){
     
  }
}*/

const RFDatePickerField=props=>{
    const { 
        classes,
        input, label, inputDateFormat, inputNote, meta: { touched, error }, 
    } = props;
    let errorStyle=error?{color: 'red'}:null
    let inputValue = input.value
    
    return (
        <FormControl className={classes.formControl}>
          <div className='container'>
            <div className='row'>
                <span style={errorStyle} >{label}</span> 
            </div>
            <div className='row'>
              <DatePicker 
                selected={inputValue ? moment(inputValue) : null}
                onChange={input.onChange}
                placeholderText={inputDateFormat}
                showYearDropdown
                scrollableYearDropdown
                isClearable={true}
                dateFormat={inputDateFormat}
                fixedHeight
              />
            </div>
            <div className='row'>
               <FormHelperText style={errorStyle}>{error?error:inputNote?inputNote:''}</FormHelperText>
            </div>
          </div>
        </FormControl>
    )
}

RFDatePickerField.propTypes = {
  inputDateFormat: PropTypes.string.isRequired,
}

export default withStyles(styles)(RFDatePickerField);


// WEBPACK FOOTER //
// ./src/components/ReduxFormComps/RFDatePickerField.js